import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
var fileDownload = require("js-file-download");
import axios from "axios";
import { request } from "@/js/http/http_request";
import { isMobile } from "@/js/mobile/mobile.js";
import { hasRole, getIdUserFromToken, isAdminNotConsultant, isConsultantNotHolding, isPricePostingUsaProSubmittedByPriceCoherence, isHolding, getClientAppData } from "@/js/http/auth.js";
import { ERROR_DATA, getErrorData, handleErrorData } from "@/js/forms.js";
import * as orderHandler from "@/js/order/order.js";
import { getIdCurrencyUsedForCartAndExplore } from "@/js/currency/currencies.js";
import { setFilters, getFilters } from "@/js/filter/filter.js";
import { defaultPagingChoices, paging, listContinents, buyLimitErrors, COMPARISON_OPERATORS } from "@/js/lists.ts";
import WineCard from "@/components/products/WineCard.vue";
import pagingComponent from "@/components/paging/PagingComponent.vue";
import indexComponent from "@/components/paging/IndexComponent.vue";
import WineFilters from "@/components/products/WineFilters.vue";
import SpiritsFilters from "@/components/products/SpiritsFilters.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import TargetSelectors from "@/components/order/TargetSelector/TargetSelectors.vue";
import ImportOrderDialogVue from "@/components/order/ImportOrderDialog.vue";
import WineStockListModal from "@/components/products/WineStockListModal.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultSearchCriterias = {
  searchLabel: "",
  filters: {
    vintage: null,
    vintageCmpOp: "=",
    stockQuantityMin: null,
    country: null,
    region: null,
    appellation: null,
    denomination: null,
    producer: null,
    wine_type: [],
    bottling: [],
    rangeAccessibilities: [],
    stockOnly: false,
    specialDealsOnly: false,
    priceRange: {
      min: null,
      max: null
    }
  },
  paging: {
    limits: paging.DEFAULT,
    currentPage: 0,
    askedPage: 0
  }
};
export default {
  name: "WineList",
  components: {
    WineCard: WineCard,
    paging: pagingComponent,
    index: indexComponent,
    ImportOrderDialogVue: ImportOrderDialogVue,
    Confirm: Confirm,
    WineFilters: WineFilters,
    SpiritsFilters: SpiritsFilters,
    TargetSelectors: TargetSelectors,
    WineStockListModal: WineStockListModal,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object,
    type: String
  },
  data: function data() {
    return {
      clientAppData: null,
      baseModel: {
        wines: [],
        numberOfWines: 0,
        numberOfPages: 0
      },
      currentOrder: orderHandler.getCurrentOrder(),
      searchCriterias: _objectSpread({}, defaultSearchCriterias),
      filterStockOnlyDefault: true,
      canExportPriceList: false,
      canImportOrder: false,
      canManageWines: false,
      hasAnySpecialDeal: false,
      isChangingCreator: false,
      selectedThirdPartyOwnerId: null,
      previousSelectedThirdPartyOwnerId: null,
      winesCancelToken: null,
      isAddingToCart: [],
      quantityByWine: [],
      loadingSearch: true,
      isLoadingFilters: true,
      listProducers: [],
      listAppellations: [],
      availableWineTypes: [],
      continents: [],
      listWineCountries: [],
      listWineRegions: [],
      listSpiritCountries: [],
      listSpiritRegions: [],
      storageLocations: [],
      currency: "EUR",
      adminUsers: [],
      thirdPartyOrder: false,
      wineFetchingInterval: null,
      isImportOrderShown: false,
      isPriceRangeFiltererShown: false,
      wineStockKey: null,
      currentWine: null,
      casingIdSelected: null,
      currentQuantity: 0,
      exportingList: {
        isPending: false,
        cancellationToken: null
      },
      comparisonOperators: Object.values(COMPARISON_OPERATORS),
      pagingLimitsChoices: defaultPagingChoices,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    thirdPartyUserId: function thirdPartyUserId() {
      var _orderHandler$getThir;
      return (_orderHandler$getThir = orderHandler.getThirdPartyUserSelected()) === null || _orderHandler$getThir === void 0 ? void 0 : _orderHandler$getThir.id_user;
    },
    isWineList: function isWineList() {
      return this.type === "wines";
    },
    isSpiritList: function isSpiritList() {
      return this.type === "spirits";
    }
  },
  watch: {
    type: function type(newVal, oldVal) {
      this.loadingSearch = true;
      this.initCriterias();
      this.search();
    },
    selectedThirdPartyOwnerId: function selectedThirdPartyOwnerId(id, oldId) {
      this.previousSelectedThirdPartyOwnerId = oldId;
    },
    isPriceRangeFiltererShown: function isPriceRangeFiltererShown(newVal) {
      if (!newVal) {
        this.clearPriceRangeFilter();
      }
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.clientAppData = getClientAppData(_this2);
            _this2.initCriterias();
            _this2.checkIfHasAnySpecialDeal();
            _this2.currency = getIdCurrencyUsedForCartAndExplore();
            orderHandler.refreshCategoryUser(_this2);
            _this2.thirdPartyOrder = hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER);
            if (_this2.thirdPartyOrder) {
              _this2.getAdminUsers();
              _this2.selectedThirdPartyOwnerId = _this2.adminUsers.find(function (x) {
                return +x.id_user === +_this2.loggedUserData.idUser;
              });
            }
            _this2.getWineFilters();
            _this2.updateStorageLocations();
            _this2.updatePriceRangeFilteredShown();
            _context.next = 12;
            return _this2.search(null, true);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    initCriterias: function initCriterias() {
      var _this$$route$query$st,
        _this$$route$query$sp,
        _this$$route$query$se,
        _this$$route$query$st2,
        _this$$route$query$st3,
        _this$$route$query$sp2,
        _this$$route$query$sp3,
        _this$$route$query$vi,
        _this$comparisonOpera,
        _this$comparisonOpera2,
        _this3 = this,
        _this$$route$query$pr,
        _this$$route$query$pr2,
        _this$$route$query,
        _this$$route$query2;
      this.filterStockOnlyDefault = isAdminNotConsultant(this.loggedUserData) ? false : this.$whitelabel.WineListStockOnlyDefault;
      this.canExportPriceList = this.$whitelabel.isExportPriceList;
      this.canImportOrder = this.$whitelabel.isExportPriceList && (isAdminNotConsultant(this.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER) || !isAdminNotConsultant(this.loggedUserData));
      this.canManageWines = hasRole(process.env.VUE_APP_ROLES_MANAGE_WINE_ADMIN);
      var hasAnyFilterQueryParam = ((_this$$route$query$st = this.$route.query.stockOnly) === null || _this$$route$query$st === void 0 ? void 0 : _this$$route$query$st.toString().length) > 0 || ((_this$$route$query$sp = this.$route.query.specialDealsOnly) === null || _this$$route$query$sp === void 0 ? void 0 : _this$$route$query$sp.toString().length) > 0 || this.$route.query.appellation || this.$route.query.denomination || this.$route.query.producer || this.$route.query.country || this.$route.query.region || this.$route.query.vintage || this.$route.query.stockQuantityMin || this.$route.query.wine_type || this.$route.query.bottling || this.$route.query.rangeAccessibilities || this.$route.query.searchLabel;
      this.searchCriterias = {
        only_active_wines: !this.canManageWines,
        searchLabel: (_this$$route$query$se = this.$route.query.searchLabel) !== null && _this$$route$query$se !== void 0 ? _this$$route$query$se : null,
        filters: {
          stockOnly: (_this$$route$query$st2 = (_this$$route$query$st3 = this.$route.query.stockOnly) === null || _this$$route$query$st3 === void 0 ? void 0 : _this$$route$query$st3.toString().asBool()) !== null && _this$$route$query$st2 !== void 0 ? _this$$route$query$st2 : this.filterStockOnlyDefault,
          specialDealsOnly: (_this$$route$query$sp2 = (_this$$route$query$sp3 = this.$route.query.specialDealsOnly) === null || _this$$route$query$sp3 === void 0 ? void 0 : _this$$route$query$sp3.toString().asBool()) !== null && _this$$route$query$sp2 !== void 0 ? _this$$route$query$sp2 : false,
          wine_type: this.isWineList && this.$route.query.wine_type ? this.$route.query.wine_type.toString().split(",").map(function (x) {
            return +x;
          }) : [],
          bottling: this.$route.query.bottling ? this.$route.query.bottling.toString().split(",").map(function (x) {
            return +x;
          }) : [],
          rangeAccessibilities: this.$route.query.rangeAccessibilities ? this.$route.query.rangeAccessibilities.toString().split(",").map(function (x) {
            return +x;
          }) : [],
          appellation: this.$route.query.appellation && {
            id_appellation: +this.$route.query.appellation
          },
          denomination: this.$route.query.denomination && {
            id_appellation: +this.$route.query.denomination
          },
          producer: this.$route.query.producer && +this.$route.query.producer,
          country: this.$route.query.country && +this.$route.query.country,
          region: this.$route.query.region && +this.$route.query.region,
          stockQuantityMin: this.$route.query.stockQuantityMin && +this.$route.query.stockQuantityMin,
          vintage: this.$route.query.vintage && +this.$route.query.vintage,
          vintageCmpOp: ((_this$$route$query$vi = this.$route.query.vintageCmpOp) === null || _this$$route$query$vi === void 0 ? void 0 : _this$$route$query$vi.length) > 0 ? (_this$comparisonOpera = (_this$comparisonOpera2 = this.comparisonOperators.find(function (x) {
            return x.textForUrlQuery === _this3.$route.query.vintageCmpOp;
          })) === null || _this$comparisonOpera2 === void 0 ? void 0 : _this$comparisonOpera2.value) !== null && _this$comparisonOpera !== void 0 ? _this$comparisonOpera : "=" : "=",
          priceRange: {
            min: (_this$$route$query$pr = this.$route.query.priceRange) !== null && _this$$route$query$pr !== void 0 && _this$$route$query$pr.min ? +this.$route.query.priceRange.min : null,
            max: (_this$$route$query$pr2 = this.$route.query.priceRange) !== null && _this$$route$query$pr2 !== void 0 && _this$$route$query$pr2.max ? +this.$route.query.priceRange.max : null
          }
        },
        paging: {
          askedPage: +((_this$$route$query = this.$route.query) === null || _this$$route$query === void 0 ? void 0 : _this$$route$query.askedPage) || 0,
          currentPage: +((_this$$route$query2 = this.$route.query) === null || _this$$route$query2 === void 0 ? void 0 : _this$$route$query2.currentPage) || 0,
          limits: isMobile() ? paging.SMALL : paging.DEFAULT
        }
      };
      var filters = getFilters();
      if (this.isWineList && filters !== null && filters !== void 0 && filters.wines && !hasAnyFilterQueryParam) {
        this.searchCriterias = _objectSpread(_objectSpread({}, this.searchCriterias), filters.wines);
      }
      if (this.isSpiritList && filters !== null && filters !== void 0 && filters.spirits && !hasAnyFilterQueryParam) {
        this.searchCriterias = _objectSpread(_objectSpread({}, this.searchCriterias), filters.spirits);
      }
    },
    updateThirdPartyUser: function updateThirdPartyUser() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.loadingSearch = true;
              _context2.next = 3;
              return _this4.checkIfHasAnySpecialDeal();
            case 3:
              _context2.next = 5;
              return _this4.updateStorageLocations();
            case 5:
              _this4.updatePriceRangeFilteredShown();
              _context2.next = 8;
              return _this4.search(null, true);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    checkIfHasAnySpecialDeal: function checkIfHasAnySpecialDeal() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var idUserTarget, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.searchCriterias.filters.specialDealsOnly = false;
              idUserTarget = !!orderHandler.getThirdPartyUserSelected() ? orderHandler.getThirdPartyUserSelected().id_user : _this5.getIdUserFromToken();
              _context3.next = 4;
              return request("/v1/commissions/has-special-deal/".concat(idUserTarget), "get", null, true, "api", null).catch(function (e) {
                throw e;
              });
            case 4:
              response = _context3.sent;
              _this5.hasAnySpecialDeal = response.data.value;
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    updateStorageLocations: function updateStorageLocations() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var idUserTarget;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this6.storageLocations = [];
              idUserTarget = !!orderHandler.getThirdPartyUserSelected() ? orderHandler.getThirdPartyUserSelected().id_user : _this6.getIdUserFromToken();
              _context4.next = 4;
              return request("/v1/warehouses/for-user-continents/".concat(idUserTarget), "get", null, true, "api", null);
            case 4:
              _this6.continents = _context4.sent.data.value;
              _this6.storageLocations = _this6.continents.map(function (x) {
                return {
                  continent_iso2: x.continentIso2,
                  name: listContinents.find(function (c) {
                    return c.id === x.continentIso2;
                  }).display_name,
                  warehouseId: x.warehouseId
                };
              });
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    updatePricePostingMonth: function updatePricePostingMonth() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this7.loadingSearch = true;
              _this7.updatePriceRangeFilteredShown();
              _context5.next = 4;
              return _this7.search(null, true);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    changeCreator: function changeCreator(value) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!value) _this8.selectedThirdPartyOwnerId = _this8.previousSelectedThirdPartyOwnerId;
              if (!(value === _this8.previousSelectedThirdPartyOwnerId)) {
                _context6.next = 3;
                break;
              }
              return _context6.abrupt("return");
            case 3:
              _context6.next = 5;
              return _this8.$refs.confirm.open("Change owner", "Are you sure you want to change the order's owner ?", {
                color: "red"
              });
            case 5:
              confirmed = _context6.sent;
              if (!confirmed) {
                _context6.next = 19;
                break;
              }
              _this8.isChangingCreator = true;
              _this = _this8;
              _context6.next = 11;
              return request("/v1/orders/".concat(_this8.currentOrder.id_order, "/creators/").concat(_this8.selectedThirdPartyOwnerId), "put", null, true, "api").catch(function () {
                _this.isChangingCreator = false;
                _this.$toasted.show("Unable to change the owner.", {
                  type: "error"
                });
              });
            case 11:
              orderHandler.removeOrderFromStorage();
              _this8.currentOrder = null;
              _this8.$EventBus.$emit("BasketRemoved");
              _this8.$EventBus.$emit("ItemRemoved", {
                detail: {
                  items: []
                }
              });
              _this8.isChangingCreator = false;
              _this8.$toasted.show("Owner changed and transfered.", {
                type: "success"
              });
              _context6.next = 20;
              break;
            case 19:
              _this8.selectedThirdPartyOwnerId = _this8.previousSelectedThirdPartyOwnerId;
            case 20:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    parseToQuery: function parseToQuery() {
      var _this$searchCriterias,
        _this$searchCriterias2,
        _this$searchCriterias3,
        _this$searchCriterias4,
        _this$searchCriterias5,
        _this$searchCriterias6,
        _this$searchCriterias7,
        _this$searchCriterias8,
        _this$searchCriterias9,
        _this$searchCriterias10,
        _this$searchCriterias11,
        _this$comparisonOpera3,
        _this$comparisonOpera4,
        _this9 = this;
      var query = _objectSpread(_objectSpread({
        tab: this.type
      }, Object.flat(_objectSpread({}, this.searchCriterias.paging), [undefined, null, NaN, ""])), {}, {
        searchLabel: this.searchCriterias.searchLabel,
        stockOnly: (_this$searchCriterias = this.searchCriterias.filters.stockOnly) === null || _this$searchCriterias === void 0 ? void 0 : _this$searchCriterias.toString(),
        specialDealsOnly: this.searchCriterias.filters.specialDealsOnly ? this.searchCriterias.filters.specialDealsOnly.toString() : undefined,
        wine_type: ((_this$searchCriterias2 = this.searchCriterias.filters.wine_type) === null || _this$searchCriterias2 === void 0 ? void 0 : _this$searchCriterias2.length) > 0 ? this.searchCriterias.filters.wine_type.join(",") : undefined,
        bottling: ((_this$searchCriterias3 = this.searchCriterias.filters.bottling) === null || _this$searchCriterias3 === void 0 ? void 0 : _this$searchCriterias3.length) > 0 ? this.searchCriterias.filters.bottling.join(",") : undefined,
        rangeAccessibilities: ((_this$searchCriterias4 = this.searchCriterias.filters.rangeAccessibilities) === null || _this$searchCriterias4 === void 0 ? void 0 : _this$searchCriterias4.length) > 0 ? this.searchCriterias.filters.rangeAccessibilities.join(",") : undefined,
        appellation: (_this$searchCriterias5 = this.searchCriterias.filters.appellation) === null || _this$searchCriterias5 === void 0 || (_this$searchCriterias5 = _this$searchCriterias5.id_appellation) === null || _this$searchCriterias5 === void 0 ? void 0 : _this$searchCriterias5.toString(),
        denomination: (_this$searchCriterias6 = this.searchCriterias.filters.denomination) === null || _this$searchCriterias6 === void 0 || (_this$searchCriterias6 = _this$searchCriterias6.id_appellation) === null || _this$searchCriterias6 === void 0 ? void 0 : _this$searchCriterias6.toString(),
        producer: (_this$searchCriterias7 = this.searchCriterias.filters.producer) === null || _this$searchCriterias7 === void 0 ? void 0 : _this$searchCriterias7.toString(),
        country: (_this$searchCriterias8 = this.searchCriterias.filters.country) === null || _this$searchCriterias8 === void 0 ? void 0 : _this$searchCriterias8.toString(),
        region: (_this$searchCriterias9 = this.searchCriterias.filters.region) === null || _this$searchCriterias9 === void 0 ? void 0 : _this$searchCriterias9.toString(),
        stockQuantityMin: (_this$searchCriterias10 = this.searchCriterias.filters.stockQuantityMin) === null || _this$searchCriterias10 === void 0 ? void 0 : _this$searchCriterias10.toString(),
        vintage: (_this$searchCriterias11 = this.searchCriterias.filters.vintage) === null || _this$searchCriterias11 === void 0 ? void 0 : _this$searchCriterias11.toString(),
        vintageCmpOp: (_this$comparisonOpera3 = (_this$comparisonOpera4 = this.comparisonOperators.find(function (x) {
          return x.value === _this9.searchCriterias.filters.vintageCmpOp;
        })) === null || _this$comparisonOpera4 === void 0 ? void 0 : _this$comparisonOpera4.textForUrlQuery) !== null && _this$comparisonOpera3 !== void 0 ? _this$comparisonOpera3 : "equal",
        only_active_wines: true
      });
      delete query.skuAcronym;
      for (var key in query) {
        if (query[key] === undefined || query[key] === null) {
          delete query[key];
        }
      }
      return query;
    },
    search: function search(options, noScroll) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this10$winesCancelTo, _orderHandler$getThir2, _orderHandler$getPric;
        var query, departureWarehouseIds, querySearch, _this, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if ((!options || !!options.smoothScroll) && !noScroll) {
                _this10.$nextTick(function () {
                  document.querySelector("#wine-list-global-container").scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                  });
                });
              }
              document.activeElement.blur();
              query = _this10.parseToQuery();
              _this10.$router.push({
                query: query
              }).catch(function () {});
              (_this10$winesCancelTo = _this10.winesCancelToken) === null || _this10$winesCancelTo === void 0 || _this10$winesCancelTo.cancel();
              _this10.winesCancelToken = axios.CancelToken.source();
              if (_this10.isWineList) {
                setFilters(function (state) {
                  return _objectSpread(_objectSpread({}, state), {}, {
                    wines: _this10.searchCriterias
                  });
                });
              }
              if (_this10.isSpiritList) {
                setFilters(function (state) {
                  return _objectSpread(_objectSpread({}, state), {}, {
                    spirits: _this10.searchCriterias
                  });
                });
              }
              departureWarehouseIds = _this10.continents.filter(function (x) {
                return x.continentIso2 === _this10.searchCriterias.filters.departureContinent;
              }).map(function (x) {
                return x.warehouseId;
              });
              querySearch = _objectSpread(_objectSpread({}, _this10.searchCriterias), {}, {
                userIdTarget: (_orderHandler$getThir2 = orderHandler.getThirdPartyUserSelected()) === null || _orderHandler$getThir2 === void 0 ? void 0 : _orderHandler$getThir2.id_user,
                isApplyActivePricePostingByDefault: false,
                pricePostingUsaProId: (_orderHandler$getPric = orderHandler.getPricePostingUsaSelected()) === null || _orderHandler$getPric === void 0 ? void 0 : _orderHandler$getPric.id,
                departureWarehouseIds: departureWarehouseIds,
                label: _this10.searchCriterias.searchLabel
              });
              querySearch.filters.isWineList = _this10.isWineList;
              querySearch.filters.isSpiritList = _this10.isSpiritList;
              _this10.loadingSearch = true;
              _this = _this10;
              _context7.next = 16;
              return request("/v1/wines", "post", querySearch, true, "api", null, _this10.winesCancelToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.loadingSearch = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to get product list", false);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 16:
              response = _context7.sent;
              _this10.baseModel = {
                wines: _toConsumableArray(response.data.wines),
                numberOfWines: response.data.total_number,
                numberOfPages: Math.ceil(response.data.total_number / _this10.searchCriterias.paging.limits)
              };
              _this10.searchCriterias.paging.currentPage = _this10.searchCriterias.paging.askedPage + 1;
              if (!_this10.searchCriterias.paging.currentPage) {
                _this10.searchCriterias.paging.currentPage = 0;
              }
              _this10.loadingSearch = false;
            case 21:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    changePage: function changePage(askedPage) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(askedPage >= 0 && askedPage <= _this11.baseModel.numberOfPages)) {
                _context8.next = 5;
                break;
              }
              _this11.searchCriterias.paging.askedPage = askedPage;
              _context8.next = 4;
              return _this11.search();
            case 4:
              _this11.$nextTick(function () {
                document.querySelector("#wine-list-global-container").scrollIntoView({
                  behavior: "auto",
                  block: "start"
                });
              });
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    advancedSearch: function advancedSearch() {
      this.searchCriterias.paging.askedPage = 0;
      this.search();
    },
    newWine: function newWine() {
      var detailsRoute = this.isWineList ? "adminWineDetails" : "adminSpiritsDetails";
      var query = {
        edit: true
      };
      return {
        name: detailsRoute,
        query: query,
        params: {
          id: "new"
        }
      };
    },
    openExportPriceList: function openExportPriceList() {
      return {
        name: "exportPriceList",
        query: this.isSpiritList ? {
          type: this.type
        } : null
      };
    },
    launchExport: function launchExport() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this12$exportingList;
        var filename, path, _this, response;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              filename = "PLATFORM_PRODUCT_LIST.xlsx";
              path = "/v1/products/export?variant=".concat(_this12.isSpiritList ? "spirits" : "wines");
              _this12.exportingList.isPending = true;
              (_this12$exportingList = _this12.exportingList.cancellationToken) === null || _this12$exportingList === void 0 || _this12$exportingList.cancel();
              _this12.exportingList.cancellationToken = axios.CancelToken.source();
              _this = _this12;
              _context10.next = 8;
              return request(path, "get", null, true, "api", "blob", _this12.exportingList.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.next = 2;
                        return Object.blobExToJsonEx(e);
                      case 2:
                        e = _context9.sent;
                        errorData = getErrorData(e, _this.managedExceptions);
                        _this.$toasted.show(errorData.message, {
                          type: errorData.type
                        });
                        _this.exportingList.isPending = false;
                        _this.exportingList.cancellationToken = null;
                      case 7:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 8:
              response = _context10.sent;
              fileDownload(response.data, filename, "application/xlsx");
              _this12.exportingList.isPending = false;
              _this12.exportingList.cancellationToken = null;
            case 12:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    importOrder: function importOrder() {
      this.isImportOrderShown = true;
    },
    closeWineStockListModal: function closeWineStockListModal() {
      var _this13 = this;
      this.$nextTick(function () {
        _this13.wineStockKey = null;
        _this13.currentWine = null;
        _this13.casingIdSelected = null;
        _this13.currentQuantity = 0;
      });
    },
    addItemToCart: function addItemToCart(wine, casingId) {
      var _arguments = arguments,
        _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _wine$stocks;
        var isFromWineStockModal, quantityFromStockModal, quantity, element, casing, isBypassingReachedBuyLimit, _this, currentOrder, _this15, _this16, index;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              isFromWineStockModal = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : false;
              quantityFromStockModal = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : 0;
              if (!(_this14.thirdPartyOrder && !orderHandler.getThirdPartyUserSelected())) {
                _context13.next = 5;
                break;
              }
              _this14.$toasted.show("You should choose a user before adding an item to your cart.", {
                type: "warning"
              });
              return _context13.abrupt("return");
            case 5:
              // We get the quantity set by the user, default 1
              quantity = 1;
              if (quantityFromStockModal > 0) {
                quantity = quantityFromStockModal;
                _this14.wineStockKey = null;
                _this14.currentWine = null;
                _this14.casingIdSelected = null;
                _this14.currentQuantity = 0;
              } else {
                element = _this14.quantityByWine.filter(function (q) {
                  return q.id_wine === wine.id_wine;
                })[0];
                if (typeof element != "undefined") {
                  // otherwise we set the item with the quantity typed
                  quantity = element.quantity;
                }
              }
              if (!(!isFromWineStockModal && isAdminNotConsultant(_this14.loggedUserData) && ((_wine$stocks = wine.stocks) === null || _wine$stocks === void 0 ? void 0 : _wine$stocks.length) >= 1)) {
                _context13.next = 15;
                break;
              }
              _this14.wineStockKey = wine.id_wine;
              _this14.currentWine = wine;
              _this14.casingIdSelected = casingId;
              _this14.currentQuantity = parseInt(quantity);
              _this14.$nextTick(function () {
                _this14.$refs.WineStockListModal.open();
              });
              _context13.next = 36;
              break;
            case 15:
              _this14.isAddingToCart = [].concat(_toConsumableArray(_this14.isAddingToCart), [wine.id_wine]);

              // Perform casing adjustment
              casing = casingId.match(/\d+/)[0];
              quantity = quantity * casing;
              isBypassingReachedBuyLimit = null;
              _this = _this14;
              _context13.next = 22;
              return orderHandler.addItemToCart(wine, quantity, casingId, _this.$toasted, _this).catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(e) {
                  var _e$value;
                  var _e$value$errorMessage, _e$value2, _e$value3, errorMessage;
                  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                    while (1) switch (_context11.prev = _context11.next) {
                      case 0:
                        _this.isAddingToCart = _toConsumableArray(_this.isAddingToCart.filter(function (x) {
                          return x !== wine.id_wine;
                        }));
                        if (!((e === null || e === void 0 || (_e$value = e.value) === null || _e$value === void 0 ? void 0 : _e$value.errorCode) === buyLimitErrors.BUY_LIMIT_REACHED.value && hasRole(process.env.VUE_APP_ROLES_BYPASS_ALL_BUY_LIMITS))) {
                          _context11.next = 7;
                          break;
                        }
                        _this.$toasted.clear();
                        errorMessage = (_e$value$errorMessage = e === null || e === void 0 || (_e$value2 = e.value) === null || _e$value2 === void 0 ? void 0 : _e$value2.errorMessage) !== null && _e$value$errorMessage !== void 0 ? _e$value$errorMessage : e === null || e === void 0 || (_e$value3 = e.value) === null || _e$value3 === void 0 ? void 0 : _e$value3.message;
                        _context11.next = 6;
                        return _this.$refs.confirm.open("Bypass buy limits for order", "".concat(errorMessage, "  ").concat(buyLimitErrors.BUY_LIMIT_REACHED.text), {
                          color: "red"
                        });
                      case 6:
                        isBypassingReachedBuyLimit = _context11.sent;
                      case 7:
                        return _context11.abrupt("return");
                      case 8:
                      case "end":
                        return _context11.stop();
                    }
                  }, _callee11);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 22:
              if (!isBypassingReachedBuyLimit) {
                _context13.next = 34;
                break;
              }
              currentOrder = orderHandler.getCurrentOrder();
              _this14.isAddingToCart = [].concat(_toConsumableArray(_this14.isAddingToCart), [wine.id_wine]);
              if (!currentOrder) {
                _context13.next = 31;
                break;
              }
              _this15 = _this14;
              _context13.next = 29;
              return request("/v1/order/".concat(currentOrder.id_order, "/bypass"), "put", null, true, "api").then(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(_) {
                  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                    while (1) switch (_context12.prev = _context12.next) {
                      case 0:
                        _context12.next = 2;
                        return orderHandler.addItemToCart(wine, quantity, casingId, _this15.$toasted, _this15, true).catch(function () {
                          _this15.isAddingToCart = _toConsumableArray(_this15.isAddingToCart.filter(function (x) {
                            return x !== wine.id_wine;
                          }));
                        });
                      case 2:
                      case "end":
                        return _context12.stop();
                    }
                  }, _callee12);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 29:
              _context13.next = 34;
              break;
            case 31:
              _this16 = _this14;
              _context13.next = 34;
              return orderHandler.addItemToCart(wine, quantity, casingId, _this14.$toasted, _this14, true).catch(function () {
                _this16.isAddingToCart = _toConsumableArray(_this16.isAddingToCart.filter(function (x) {
                  return x !== wine.id_wine;
                }));
              });
            case 34:
              index = _this14.isAddingToCart.indexOf(wine.id_wine);
              _this14.isAddingToCart.splice(index, 1);
            case 36:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    changeQuantityOrder: function changeQuantityOrder(_ref4) {
      var idWine = _ref4.idWine,
        quantity = _ref4.quantity;
      if (typeof this.quantityByWine.filter(function (q) {
        return q.id_wine === idWine;
      })[0] === "undefined") {
        // unknown reference for this session of shopping, we add it to the array
        this.quantityByWine.push({
          id_wine: idWine,
          quantity: quantity
        });
      } else {
        // Already add a value, so we update it
        var element = this.quantityByWine.filter(function (q) {
          return q.id_wine === idWine;
        })[0];
        element.quantity = quantity;
      }
    },
    getWineFilters: function getWineFilters() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this, response, responseCountries, listCountries, responseRegions, listRegions, countryIdWithWineRegion, countryIdWithSpiritRegion;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this17.isLoadingFilters = true;
              _this = _this17;
              _context14.next = 4;
              return request("/v1/wines/filters", "post", _this.searchCriterias, true, "api").catch(function (e) {
                _this.isLoadingFilters = false;
                throw e;
              });
            case 4:
              response = _context14.sent;
              _this17.listProducers = _toConsumableArray(response.data.producers);
              _this17.listAppellations = _toConsumableArray(response.data.appellations);
              _this17.availableWineTypes = _toConsumableArray(response.data.wine_types);
              if (!!_this.$route.query.appellation) {
                _this17.searchCriterias.filters.appellation = _this17.listAppellations.find(function (x) {
                  return +x.id_appellation === +_this17.$route.query.appellation;
                });
              }
              if (!!_this.$route.query.denomination) {
                _this17.searchCriterias.filters.denomination = _this17.listAppellations.flatMap(function (x) {
                  return x.denominations;
                }).find(function (x) {
                  return +x.id_appellation === +_this17.$route.query.denomination;
                });
              }
              if (!!_this17.$route.query.wine_type) {
                _this17.searchCriterias.filters.wine_type = _this17.availableWineTypes.filter(function (x) {
                  return _this17.$route.query.wine_type.split(",").includes(x.id_type.toString());
                }).map(function (x) {
                  return x.id_type;
                });
              }
              _context14.next = 13;
              return request("/v1/countries?havingProducers=true", "post", _this.clientAppData, false, "api").catch(function (e) {
                _this.isLoadingFilters = false;
                throw e;
              });
            case 13:
              responseCountries = _context14.sent;
              listCountries = _toConsumableArray(responseCountries.data.countries);
              _context14.next = 17;
              return request("/v1/regions", "get", null, true, "api").catch(function (e) {
                _this.isLoadingFilters = false;
                throw e;
              });
            case 17:
              responseRegions = _context14.sent;
              listRegions = _toConsumableArray(responseRegions.data);
              _this17.listWineRegions = _toConsumableArray(listRegions.filter(function (x) {
                return x.isWineRegion;
              }));
              _this17.listSpiritRegions = _toConsumableArray(listRegions.filter(function (x) {
                return x.isSpiritRegion;
              }));
              countryIdWithWineRegion = _toConsumableArray(new Set(_this17.listWineRegions.map(function (x) {
                return x.country.id_country;
              })));
              _this17.listWineCountries = listCountries.filter(function (x) {
                return countryIdWithWineRegion.includes(x.id_country);
              });
              countryIdWithSpiritRegion = _toConsumableArray(new Set(_this17.listSpiritRegions.map(function (x) {
                return x.country.id_country;
              })));
              _this17.listSpiritCountries = listCountries.filter(function (x) {
                return countryIdWithSpiritRegion.includes(x.id_country);
              });
              _this17.isLoadingFilters = false;
            case 26:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    getAdminUsers: function getAdminUsers() {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var response;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return request("/v1/users", "post", {
                user_group: ["ADMIN"],
                roles: [process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER],
                active: true
              }, true, "api").catch(function (e) {
                throw e;
              });
            case 2:
              response = _context15.sent;
              _this18.adminUsers = _toConsumableArray(response.data.users);
            case 4:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    filtersChanged: function filtersChanged(options) {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _this19.searchCriterias = _objectSpread(_objectSpread({}, _this19.searchCriterias), {}, {
                paging: _objectSpread(_objectSpread({}, _this19.searchCriterias.paging), {}, {
                  askedPage: 0,
                  currentPage: 0
                })
              });
              _context16.next = 3;
              return _this19.search(options);
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    updatePriceRangeFilteredShown: function updatePriceRangeFilteredShown() {
      var _this20 = this;
      this.$nextTick(function () {
        var _orderHandler$getPric2;
        var isAdminOrConsultantOrHolding = isAdminNotConsultant(_this20.loggedUserData) || isConsultantNotHolding(_this20.loggedUserData) || isHolding(_this20.loggedUserData);
        var hasValidPricePostingId = ((_orderHandler$getPric2 = orderHandler.getPricePostingUsaSelected()) === null || _orderHandler$getPric2 === void 0 ? void 0 : _orderHandler$getPric2.id) > 0;
        var isPriceposted = isPricePostingUsaProSubmittedByPriceCoherence(_this20.loggedUserData);
        var showPriceRange = isAdminOrConsultantOrHolding && hasValidPricePostingId || isPriceposted;
        _this20.isPriceRangeFiltererShown = showPriceRange;
      });
    },
    clearPriceRangeFilter: function clearPriceRangeFilter() {
      this.searchCriterias.filters.priceRange = {
        min: null,
        max: null
      };
    },
    getIdUserFromToken: getIdUserFromToken,
    isMobile: isMobile,
    isAdminNotConsultant: isAdminNotConsultant
  }
};